import React from "react";

import tryRootstockImg from '../../images/use/try_rootstock.svg'
import {Button} from "../global/Button";

export const TryRootstock = (props) => {
  const data = props.data;

  return (
    <section className="py-6">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-5">
            <img className="mb-md-0 mb-6" src={tryRootstockImg} alt="Try Rootstock" loading='lazy'/>
          </div>
          <div className="col-lg-5 col-md-7">
            <h2 className="h3 mb-6 mb-md-6">{data.title}</h2>
            <p className="mb-6">{data.columnLeft}</p>
            <Button
              title={data.link.title}
              url={data.link.url}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
